export const TRACKING_ID_PLACEHOLDER = "[adora-tracking-id]";
